import { render, staticRenderFns } from "./CustomerSaveForm.vue?vue&type=template&id=3d737ead"
import script from "./CustomerSaveForm.vue?vue&type=script&lang=js"
export * from "./CustomerSaveForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerSaveForm.vue?vue&type=style&index=0&id=3d737ead&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports